<template>
  <vs-popup class="add-new-incoterms" id="popup" :title="isCreateMode ? 'CREATE MERGED FIELD' : 'UPDATE MERGED FIELD'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-incoterms-popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                <small class="label">Field Type</small>
                <v-select :clearable="false" placeholder="" v-model="form.type" :options="['text', 'dropdown']"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="!isCreateMode">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name" name="name" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="tag" name="tag" rules="upper_case" v-slot="{ errors }">
                <small class="label">Mailchimp Tag</small>
                <vs-input v-model="form.tag" name="tag" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-8 mt-8 vx-row" v-if="form.type === 'dropdown'">
            <div class="w-full vx-col md:w-full md:mb-0">
              <small class="label">Dropdown Options</small>
              <div class="vx-row  ml-4" v-for="(dropdown, index) in form.data.dropdown" :key="index">
                <div class="w-full vx-col md:w-4/5 md:mb-0 my-2">
                  <vs-input class="w-full" v-model="form.data.dropdown[index]"></vs-input>
                </div>
                <div class="w-full vx-col md:w-1/5 md:mb-0">
                  <vs-button @click.stop="form.data.dropdown.splice(index, 1)" class="mt-4" size="small" color="danger" icon-pack="feather" icon="icon-trash-2"></vs-button>
                </div>
              </div>
              <div class="vx-row ml-8 mt-4">
                <vs-button @click.stop="form.data.dropdown.push('')" size="small" color="primary" icon-pack="feather" icon="icon-plus">add new
                  option</vs-button>
              </div>
              <!-- <vs-chips placeholder="Add dropdown options (type and press enter)" v-model="form.data.dropdown">
                <vs-chip
                  color="primary"
                  :key="chip"
                  @click="remove(chip)"
                  v-for="chip in form.data.dropdown"
                  closable>
                  {{ chip }}
                </vs-chip>
              </vs-chips> -->
            </div>
          </div>

          <div class="mb-3 vx-row" v-if="!isCreateMode">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="is_hidden" name="is_hidden" rules="required" v-slot="{ errors }">
                <small class="label">Is this a hidden field?</small>
                <v-select :clearable="false" placeholder="" v-model="form.is_hidden" :reduce="option => option.value"
                  label="name" :options="[{ name: 'Yes', value: true }, { name: 'No', value: false }]"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row" v-if="!form.is_hidden">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="is_required" name="is_required" rules="required" v-slot="{ errors }">
                <small class="label">Is this a compulsory field?</small>
                <v-select :clearable="false" placeholder="" v-model="form.is_required" :reduce="option => option.value"
                  label="name" :options="[{ name: 'Yes', value: true }, { name: 'No', value: false }]"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="default_value" name="default_value" rules="" v-slot="{ errors }"
                v-if="form.type === 'text'">
                <small class="label">Default value</small>
                <vs-input v-model="form.default_value" name="default_value" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
              <ValidationProvider vid="default_value" name="default_value" rules="" v-slot="{ errors }"
                v-if="form.type === 'dropdown'">
                <small class="label">Default Value</small>
                <v-select :clearable="false" placeholder="" v-model="form.default_value" :options="form.data.dropdown"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CRMRepository = RepositoryFactory.get('crm');
const CcpRepository = RepositoryFactory.get('ccp');

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      type: 'text',
      data: { dropdown: [] },
      is_hidden: false
    },
    isCreateMode: true
  }
}

export default {
  name: 'CreateMergedFieldPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchIncotermDetails()
        } else {
          this.isCreateMode = true
        }
      } catch (error) {

      }
    },
    remove(item) {
      this.form.data.dropdown.splice(this.form.data.dropdown.indexOf(item), 1)
    },
    async fetchIncotermDetails() {
      await this.$vs.loading({
        container: '#create-incoterms-popup',
        scale: 0.45
      })
      try {
        const { data } = (await CRMRepository.getCrmMergedFieldDetails(this.id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
    },
    async onClickCreateSite() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-incoterms-popup',
        scale: 0.45
      })
      try {
        if (this.isCreateMode) {
          if (this.form.type === 'text') {
            delete this.form.data.dropdown
          } else {
            this.form.data.dropdown = this.form.data.dropdown.filter((x) => !!x)
          }
          await CRMRepository.createCrmMergedFields({ merge_fields: [this.form] });
          this.showSuccessMessage('Field added successfully!');
        } else {
          if (this.form.type === 'dropdown') {
            this.form.data.dropdown = this.form.data.dropdown.filter((x) => !!x)
          } 
          await CRMRepository.updateCrmMergedFields(this.id, this.form);
          this.showSuccessMessage('Field updated successfully!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
    },
  },
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-incoterms>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}
</style>
